import React from 'react';
import PropTypes from 'prop-types';

const ChatMessageLabel = ({ label }) => <div className="chat-list_title">{label}</div>;

ChatMessageLabel.propTypes = {
  label: PropTypes.string.isRequired,
};

export default React.memo(ChatMessageLabel);



// WEBPACK FOOTER //
// ./app/javascript/common/components/ChatMessage/ChatMessageLabel.js